import axios from "axios";
import AppConfiguration from "dataProvider/config";
import cookie from "lib/cookie";

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.gAppId = localStorage.getItem("device_id") || "";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.gAppId = localStorage.getItem("device_id") || "";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

let headers = {
  responseType: "blob",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
  "Access-Control-Allow-Headers":
    "Origin,Authorization,Content-Type,Accept,User-Agent,Cache-Control,Keep-Alive,X-Requested-With,If-Modified-Since",
};

function preSendData(data) {
  for (let prop in data) {
    if (!data.hasOwnProperty(prop)) continue;
    let dataElement = data[prop];
    if (
      dataElement == null ||
      dataElement === "null" ||
      dataElement === "" ||
      dataElement === "undefined"
    ) {
      delete data[prop];
    }
  }

  return data;
}

//axios for amdin ghtk
const configAdmin = {
  headers,
  timeout: 180000,
};

//axios for chat service
const configChat = {
  headers,
  timeout: 180000,
};
configChat.baseURL = AppConfiguration.apiBaseChat;

const configMap = {
  headers,
  timeout: 180000,
};
configMap.baseURL = AppConfiguration.apiBaseMap;

const configThietBi = {
  headers,
  timeout: 180000,
};
configThietBi.baseURL = AppConfiguration.apiBaseThietBi;

const configTracker = {
  headers,
  timeout: 180000,
};
configTracker.baseURL = AppConfiguration.apiBaseTracker;

const configSms = {
  headers: {
    ...headers,
  },
  timeout: 180000,
};

const configTripod = {
  headers,
  timeout: 180000,
  baseURL: AppConfiguration.apiBaseTripod,
};

const configBarrier = {
  headers,
  timeout: 180000,
  baseURL: AppConfiguration.apiBaseBarrier,
};

const configAdmcsm = {
  headers,
  timeout: 180000,
  baseURL: AppConfiguration.apiBaseAdmcsm + "/admcsm",
};

configSms.baseURL = AppConfiguration.apiBaseSms;
const requestAdmin = axios.create(configAdmin);
const request = axios.create(configChat);
const requestMap = axios.create(configMap);
const requestTracker = axios.create(configTracker);
const requestSms = axios.create(configSms);
const tripodRequest = axios.create(configTripod);
const barrierRequest = axios.create(configBarrier);

const admcsmRequest = axios.create(configAdmcsm);

// Interceptors
// Add a request interceptor
requestAdmin.interceptors.request.use(
  function (config) {
    config.headers.gAppId = localStorage.getItem("device_id") || "";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
requestMap.interceptors.request.use(
  function (config) {
    config.headers.gAppId = localStorage.getItem("device_id") || "";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// export const get = (endpoint, token) => {
/*
 * Check token hết hạn*/

export const get = (endpoint, token) => {
  if (token === undefined || !token || token === "null")
    token = "i4osd681rut4ipa27dsct1j5g2";
  const config = {
    withCredentials: true,
    headers: {
      Authorization: "Bearer " + token,
      isMobileApp: 1,
      appVersion: 10000,
    },
  };
  return requestAdmin.get(endpoint, config);
};

export const post = (
  endpoint,
  data,
  configCustom = {
    // withCredentials: true,
    headers: {
      isMobileApp: 1,
      appVersion: 10000,
    },
  },
  token
) => {
  if (token === undefined || !token) token = cookie.get("PHPSESSID");
  let config = {
    headers: {
      Authorization: "Bearer " + token,
      isMobileApp: 1,
      appVersion: 10000,
    },
  };
  if (
    token &&
    configCustom !== undefined &&
    configCustom &&
    !configCustom.headers
  ) {
    config = {
      ...config,
      ...configCustom,
    };
  }

  data = preSendData(data);

  let formData = new FormData();
  if (data && data.hasFile) {
    config = {
      ...config,
      header: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };
    delete data["hasFile"];
    for (let prop in data) {
      if (!data.hasOwnProperty(prop)) continue;
      if (Array.isArray(data[prop])) {
        data[prop].forEach((dt) => {
          formData.append(prop, dt);
        });
      } else {
        formData.append(prop, data[prop]);
      }

      delete data[prop];
    }
    data = formData;
  }

  return requestAdmin.post(endpoint, data, config);
};

export const puts = (
  endpoint,
  data,
  config = {
    headers: {},
  }
) => {
  if (localStorage.getItem("token")) {
    config = {
      ...config,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
  }
  return request.put(endpoint, data, config);
};

export const deletes = (
  endpoint,
  data,
  config = {
    headers: {},
  }
) => {
  if (localStorage.getItem("token")) {
    config = {
      ...config,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
  }
  return request.delete(endpoint, config);
};

//base for iot.ghtk.vn
const makeHeader = (configCustom, additionToken = "") => {
  let ghtkToken = localStorage.getItem("ghtk-token-storage");

  if (!ghtkToken) {
    return {
      headers: {},
    };
  }

  ghtkToken = JSON.parse(ghtkToken);

  let config = {
    headers: {
      Authorization: "Bearer " + ghtkToken.accessToken.accessToken,
    },
  };
  if (additionToken) {
    config.headers["x-access-token"] = additionToken;
  }

  if (configCustom !== undefined && configCustom && !configCustom.headers)
    config = {
      ...config,
      ...configCustom,
    };

  return config;
};

export const getRequestMap = (endpoint, configCustom) => {
  const config = makeHeader(configCustom);
  return requestMap.get(endpoint, config);
};

export const postRequestMap = (endpoint, data, configCustom = {}) => {
  let config = makeHeader(configCustom);

  data = preSendData(data);

  let formData = new FormData();
  if (data && data.hasFile) {
    config = {
      ...config,
      header: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };
    delete data["hasFile"];
    for (let prop in data) {
      if (!data.hasOwnProperty(prop)) continue;
      if (Array.isArray(data[prop])) {
        data[prop].forEach((dt) => {
          formData.append(prop, dt);
        });
      } else {
        formData.append(prop, data[prop]);
      }

      delete data[prop];
    }
    data = formData;
  }

  return requestMap.post(endpoint, data, config);
};

export const putRequestMap = (endpoint, data, configCustom = {}) => {
  let config = makeHeader(configCustom);

  data = preSendData(data);

  let formData = new FormData();
  if (data && data.hasFile) {
    config = {
      ...config,
      header: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };
    delete data["hasFile"];
    for (let prop in data) {
      if (!data.hasOwnProperty(prop)) continue;
      if (Array.isArray(data[prop])) {
        data[prop].forEach((dt) => {
          formData.append(prop, dt);
        });
      } else {
        formData.append(prop, data[prop]);
      }

      delete data[prop];
    }
    data = formData;
  }
  return requestMap.put(endpoint, data, config);
};
export const deleteRequestMap = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);

  return requestMap.delete(endpoint, config);
};

// base for thietbi.ghtk.vn
export const getRequestThietBi = (endpoint, configCustom) => {
  return;
};
export const postRequestThietBi = (endpoint, data, configCustom = {}) => {
  return;
};

export const getRequestCustomThietbi = (endpoint, configCustom) => {
  return;
};

// base for tracker
export const getRequestTracker = (apiEndPoint, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestTracker.get(apiEndPoint, config);
};
export const deleteRequestTracker = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestTracker.delete(endpoint, config);
};
export const postRequestTracker = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestTracker.post(endpoint, data, config);
};
export const putRequestTracker = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestTracker.put(endpoint, data, config);
};

// base for sms
export const getRequestSms = (apiEndPoint, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestSms.get(apiEndPoint, config);
};
export const deleteRequestSms = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestSms.delete(endpoint, config);
};
export const postRequestSms = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestSms.post(endpoint, data, config);
};
export const putRequestSms = (endpoint, data, configCustom = {}) => {
  const config = makeHeader(configCustom);
  return requestSms.put(endpoint, data, config);
};

/*
 * base for tripod*/
export const tripodGetRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return tripodRequest.get(api, config);
};
export const tripodPostRequest = (api, configCustom, data) => {
  const config = makeHeader(configCustom);
  return tripodRequest.post(api, config, data);
};
export const tripodPutRequest = (api, configCustom, data) => {
  const config = makeHeader(configCustom);
  return tripodRequest.get(api, config, data);
};
export const tripodDeleteRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return tripodRequest.delete(api, config);
};

/*
 * base for barrier*/
export const barrierGetRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return barrierRequest.get(api, config);
};
export const barrierPostRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom);
  return barrierRequest.post(api, data, config);
};
export const barrierPutRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom);
  return barrierRequest.put(api, data, config);
};
export const barrierDeleteRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return barrierRequest.delete(api, config);
};

/*
 * base for admcsm*/
export const admcsmGetRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return admcsmRequest.get(api, config);
};
export const admcsmPostRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom);
  return admcsmRequest.post(api, data, config);
};
export const admcsmPutRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom);
  return admcsmRequest.put(api, data, config);
};
export const admcsmDeleteRequest = (api, configCustom) => {
  const config = makeHeader(configCustom);
  return admcsmRequest.delete(api, config);
};

/*
 * base for printer*/
const HARD_TOKEN_PRINTER = "mCkA34oMf1YpK2hk5rgRMpxk2CiycrWH";
export const printerGetRequest = (api, configCustom) => {
  const config = makeHeader(configCustom, HARD_TOKEN_PRINTER);
  return requestMap.get(api, config);
};
export const printerPostRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom, HARD_TOKEN_PRINTER);
  return requestMap.post(api, data, config);
};
export const printerPutRequest = (api, data, configCustom) => {
  const config = makeHeader(configCustom, HARD_TOKEN_PRINTER);
  return requestMap.put(api, data, config);
};
export const printerDeleteRequest = (api, configCustom) => {
  const config = makeHeader(configCustom, HARD_TOKEN_PRINTER);
  return requestMap.delete(api, config);
};
